module.exports = __webpack_public_path__ + "img/Butterfly_00376.c97e72ec.png";